const uuid = require('uuid');
module.exports.getUUID = () => uuid();
